export default {
  title: 'Ostatnie wyniki kampanii',
  recipients: '{{recipients}} odbiorców',
  error_messages: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
